<template>
  <div class="signature-preview">
    <div class="signature-preview__row signature-preview__row--header">
      <div class="signature-preview__cell signature-preview__cell--header">{{ displayHeader(signature.left.header) }}</div>
      <div class="signature-preview__cell signature-preview__cell--header">{{ displayHeader(signature.right.header) }}</div>
    </div>
    <div class="signature-preview__row signature-preview__row--sign">
      <div class="signature-preview__cell">
        <div class="signature-preview__sign-line"></div>
      </div>
      <div class="signature-preview__cell">
        <div class="signature-preview__sign-line"></div>
      </div>
    </div>
    <div class="signature-preview__row">
      <div class="signature-preview__cell signature-preview__cell--meta">{{ displayName(signature.left.name) }}</div>
      <div class="signature-preview__cell signature-preview__cell--meta">{{ displayName(signature.right.name) }}</div>
    </div>
    <div class="signature-preview__row">
      <div class="signature-preview__cell signature-preview__cell--meta">{{ displayPosition(signature.left.position) }}</div>
      <div class="signature-preview__cell signature-preview__cell--meta">{{ displayPosition(signature.right.position) }}</div>
    </div>
    <div class="signature-preview__row">
      <div class="signature-preview__cell signature-preview__cell--meta">{{ displayDate(signature.left.date) }}</div>
      <div class="signature-preview__cell signature-preview__cell--meta">{{ displayDate(signature.right.date) }}</div>
    </div>
  </div>
</template>

<script>
import { buildAgreementSignaturePreview } from '@/utils/agreement-preview-sections'

export default {
  name: 'AgreementSignaturePreview',
  props: {
    section: {
      type: [Object, String],
      required: true
    },
    leftHeader: {
      type: String,
      default: 'Mae Fah Luang University'
    },
    rightHeader: {
      type: String,
      default: ''
    }
  },
  computed: {
    signature() {
      return buildAgreementSignaturePreview(this.section, {
        leftHeader: this.leftHeader,
        rightHeader: this.rightHeader
      })
    }
  },
  methods: {
    displayHeader(value) {
      return String(value || '').trim() || '........................................'
    },
    displayName(value) {
      return String(value || '').trim() || '(Name) ........................................'
    },
    displayPosition(value) {
      return String(value || '').trim() || '(Position) ........................................'
    },
    displayDate(value) {
      return String(value || '').trim() || 'Date:'
    }
  }
}
</script>

<style scoped lang="scss">
.signature-preview {
  background: #ffffff;
  border: 1px solid #d7dde8;
  border-radius: 16px;
  overflow: hidden;
}

.signature-preview__row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.signature-preview__row + .signature-preview__row {
  border-top: 1px solid #d7dde8;
}

.signature-preview__cell {
  min-width: 0;
  padding: 12px 14px;
  white-space: pre-wrap;
}

.signature-preview__cell + .signature-preview__cell {
  border-left: 1px solid #d7dde8;
}

.signature-preview__cell--header {
  color: #344767;
  font-weight: 700;
}

.signature-preview__cell--meta {
  color: #52606d;
  line-height: 1.55;
}

.signature-preview__row--sign .signature-preview__cell {
  align-items: flex-end;
  display: flex;
  min-height: 170px;
}

.signature-preview__sign-line {
  border-bottom: 3px dotted #344767;
  width: 100%;
}

@media (max-width: 768px) {
  .signature-preview__row {
    grid-template-columns: 1fr;
  }

  .signature-preview__cell + .signature-preview__cell {
    border-left: 0;
    border-top: 1px solid #d7dde8;
  }

  .signature-preview__row--sign .signature-preview__cell {
    min-height: 120px;
  }
}
</style>
